class ProgressBarController {
  constructor() {
    this.events();
  }

  events() {
    window.addEventListener("DOMContentLoaded", () => {
      /////////////
      // FINALE //
      let finaleProgressbar = document.querySelectorAll("#finale-progressbar");
      let preselectionsProgressbar = document.querySelectorAll(
        "#preselections-progressbar"
      );

      function updateFinaleProgressBar(finalePercentage) {
        if (finalePercentage >= 0 && finalePercentage <= 100) {
          for (let i = 0; i < finaleProgressbar.length; i++) {
            finaleProgressbar[i].style.width = finalePercentage + "%";
          }
        }
      }

      function updatePreselectionsProgressBar(preselectionsPercentage) {
        if (preselectionsPercentage >= 0 && preselectionsPercentage <= 100) {
          for (let i = 0; i < preselectionsProgressbar.length; i++) {
            preselectionsProgressbar[i].style.width =
              preselectionsPercentage + "%";
          }
        }
      }

      let totalFinaleTickets = document.getElementById(
        "total-finale-tickets"
      ).innerHTML;
      let availableFinaleTickets = document.getElementById(
        "available-finale-tickets"
      ).innerHTML;
      let totalpreselectionsTickets = document.getElementById(
        "total-preselections-tickets"
      ).innerHTML;
      let availablepreselectionsTickets = document.getElementById(
        "available-preselections-tickets"
      ).innerHTML;

      let finalePercentage =
        (100 / totalFinaleTickets) * availableFinaleTickets;
      let preselectionsPercentage =
        (100 / totalpreselectionsTickets) * availablepreselectionsTickets;

      if (finalePercentage > 100) {
        finalePercentage = 100;
      }
      if (finalePercentage < 0) {
        finalePercentage = 0;
      }
      if (preselectionsPercentage > 100) {
        preselectionsPercentage = 100;
      }
      if (preselectionsPercentage < 0) {
        preselectionsPercentage = 0;
      }

      updateFinaleProgressBar(finalePercentage);
      updatePreselectionsProgressBar(preselectionsPercentage);
    });
  }
}

export default ProgressBarController;
